"use client";

import Image from "next/image";

import { BorderBeam } from "@/components/ui/border-beam";
import { Card, CardContent } from "@/components/ui/card";
import { cn } from "@/lib/utils";

export function AuthCentered({
  className,
  children,
  image,
}: {
  className?: string;
  children: React.ReactNode;
  image?: string;
}) {
  return (
    <div
      className={cn(
        "flex relative flex-col gap-6 min-h-screen px-4 pt-28 pb-8 md:px-6 justify-center items-center overflow-hidden",
        className
      )}
    >
      <Card
        className={cn(
          "relative z-10 p-0 w-full max-w-sm sm:max-w-2xl overflow-hidden border-none shadow-xl bg-card/95",
          image && "sm:max-w-4xl lg:max-w-5xl"
        )}
      >
        <BorderBeam
          duration={6}
          size={400}
          borderWidth={3}
          delay={3}
          className="from-transparent via-primary to-transparent"
        />
        <CardContent
          className={cn("grid", image && "md:grid-cols-2 lg:grid-cols-[1.2fr_1fr] px-0")}
        >
          {children}
          {image && (
            <div className="relative hidden md:block">
              <Image
                src={image}
                alt="Login illustration"
                fill
                className="object-cover dark:brightness-[0.9]  rounded-r-xl"
                priority
              />
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
